// extracted by mini-css-extract-plugin
module.exports = {"titleText":"index_titleText__1yWu5"};